import { css } from "@emotion/css";
import { $, type Properties, resolve, signal } from "signlets";

import { Button } from "./Button";
import { classes } from "./classes";
import { Loading } from "./Loading";

const style = css`
  &.loading {
    pointer-events: none;
  }
`;

export type LoadingButtonProps = {
  disabled?: boolean;
  primary?: boolean;
  class?: string;
  onClick: (_: MouseEvent) => Promise<void>;
  children?: JSX.Element;
};

export const LoadingButton = ({
  disabled,
  primary,
  class: _class,
  onClick,
  children,
}: Properties<LoadingButtonProps>) => {
  const [loading, setLoading] = signal(false);

  const _onClick = async (_: MouseEvent) => {
    setLoading(true);
    try {
      await onClick(_);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      disabled={disabled}
      onClick={_onClick}
      primary={primary}
      class={$(() => classes(style, loading() && "loading", resolve(_class)))}
    >
      {children}
      <Loading visible={loading} />
    </Button>
  );
};
